import React, { useState, useEffect, Fragment } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import * as constants from "../../Common/constants.js";

import SideBar from "../Common/sidebar/sidebar.jsx";
import SideBarAdmin from "../Common/sidebar-admin/sidebar-admin.jsx";
import TopBar from "../Common/topbar/topbar.jsx";

import "./layout.css";
import "./../../../Styles/site.css";

function Layout(props) {

    const [role, setRole] = useState("");

    useEffect(getRole, []);

    function getRole() {
        $.ajax({
            url: "/user/getuserrole",
            method: "GET",
            contentType: "application/json; charset=utf-8"
        })
        .done((response, textStatus, xhr) => {
            if (textStatus === "success") {
                setRole(response);
            }
        })
        .fail((xhr, textStatus, errorThrown) => {
            console.log(errorThrown);
        });
    }

    return (
        <div styleName="main-container">
            {
                role !== "" &&
                (
                    role.toUpperCase() === constants.Role.Admin.toUpperCase() ?
                        (
                            <SideBarAdmin />
                        )
                        :
                        (
                            <SideBar />
                        )
                )
            }
            <div styleName="content">
                <TopBar />
                <div styleName="main-list-header">
                    <div styleName="main-list-header__title">
                        {props.title}
                    </div>
                    {
                        props.rightHeaderItems
                    }
                </div>
                <div styleName="main-content-container">
                    {
                        props.children
                    }
                </div>
            </div>
        </div>
    );
}

export default Layout;